import request from '@/utils/request';
import config from '@/config';

const { apiInfo } = config;
const masterDataUrl = `${apiInfo.masterData.prefix}${apiInfo.masterData.group}`;

export function getShipment(
    country,
    CustomerDisplay,
    ChannelDisplay,
    CustomerID,
    pageIndex,
    pageSize
) {
    const url =
        masterDataUrl +
        `/CCMapping?country=${country}&CustomerDisplay=${CustomerDisplay}&ChannelDisplay=${ChannelDisplay}&CustomerID=${CustomerID}&pageIndex=${pageIndex}&pageSize=${pageSize}`;

    return request({
        url: url,
        method: 'get'
    });
}

export function getGranularity(dataSet) {
    const url = masterDataUrl + '/GetGranularity';

    return request({
        url: url,
        method: 'post',
        data: {
            ...dataSet
        }
    });
}

export function getFilesLog(
    country,
    category,
    ImportDateB,
    ImportDateE,
    userid,
    fileStatus,
    FileType,
    fileName,
    pageIndex,
    pageSize
) {
    const url =
        masterDataUrl +
        `/FilesLog?country=${country}&category=${category}&ImportDateB=${ImportDateB}&ImportDateE=${ImportDateE}&userid=${userid}&fileStatus=${fileStatus}&FileType=${FileType}&fileName=${fileName}&pageIndex=${pageIndex}&pageSize=${pageSize}`;

    return request({
        url: url,
        method: 'get'
    });
}

export function getFactbook(type, country, category, pageIndex, pageSize) {
    const url =
        masterDataUrl +
        `/Factbook?type=${type}&country=${country}&category=${category}&pageIndex=${pageIndex}&pageSize=${pageSize}`;

    return request({
        url: url,
        method: 'get'
    });
}

export function getShipmentMapping(dataSet) {
    const url = masterDataUrl + '/ShipmentMapping';

    return request({
        url: url,
        method: 'post',
        data: { ...dataSet }
    });
}

export function getFactbookEx(type, country, category, pageIndex, pageSize) {
    const url =
        masterDataUrl +
        `/FactbookEx?type=${type}&country=${country}&category=${category}&pageIndex=${pageIndex}&pageSize=${pageSize}`;

    return request({
        url: url,
        method: 'get'
    });
}

export function MasterDelete(dataSet) {
    const url = masterDataUrl + '/MasterDelete';

    return request({
        url: url,
        method: 'post',
        data: { ...dataSet }
    });
}



// WEBPACK FOOTER //
// ./src/api/masterData.js